import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { getTranslatedOptions } from '../../../../../utils/translation'
import { Checkbox, CHECKBOX_SIZE } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import { ButtonSelect } from '../../../../Select'
import {
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OPTIONS,
} from '../RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal.constants'

function FormFields() {
  const { t } = useTranslation()

  const groupOptions = getTranslatedOptions({
    options: ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OPTIONS,
    t,
  })

  return (
    <FormFieldsContainer>
      <FormikField
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={ButtonSelect}
        controlProps={{
          indicatorsProps: {
            ButtonClear: null,
          },
        }}
        fieldComponentProps={{
          label: t('RequestProfile.AttachedRequestsRecipientGroupLabelKey'),
        }}
        listProps={{
          headerProps: { Search: null },
        }}
        name={ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME}
        options={groupOptions}
      />
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('RequestProfile.AttachedRequestsExcludeArchivedLabelKey')}
        name={ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME}
        size={CHECKBOX_SIZE.small}
      />
    </FormFieldsContainer>
  )
}

export default FormFields
